// extracted by mini-css-extract-plugin
export default {"selector":"Selector-module--selector--8bf08","tab":"Selector-module--tab--a58b0","active":"Selector-module--active--1db08"};